<script setup>
</script>
<template>
  <div class="bg-white rounded-md px-[16px] py-[16px] lg:px-[108px] lg:py-[40px]">
    <slot />
  </div>
</template>
